// pages/PlaceholderPage.js
// Placeholder לדפים שעוד לא נבנו
// יוחלף בדפים אמיתיים ב-v0.2.0+

import { Box, Typography, Chip } from '@mui/material';
import ConstructionIcon from '@mui/icons-material/Construction';
import { useTranslation } from 'react-i18next';

const VERSION_MAP = {
  dataEntry: 'v0.4.0',
  metricHistory: 'v0.4.0',
  reports: 'v0.4.0',
  units: 'v0.2.0',
  categories: 'v0.3.0',
  classifications: 'v0.2.0',
  metricTypes: 'v0.3.0',
  metrics: 'v0.3.0',
  users: 'v0.2.0',
  companySettings: 'v0.2.0',
};

export default function PlaceholderPage({ pageKey }) {
  const { t } = useTranslation();
  const version = VERSION_MAP[pageKey] || 'v0.2.0';

  return (
    <Box
      data-testid={`${pageKey}__placeholder`}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '50vh',
        gap: 2,
        textAlign: 'center',
      }}
    >
      <ConstructionIcon sx={{ fontSize: 64, color: 'text.disabled', opacity: 0.5 }} />
      <Typography variant="h5" color="text.secondary">
        {t(`nav.${pageKey}`)}
      </Typography>
      <Typography variant="body2" color="text.disabled">
        {t('placeholder.comingSoon')}
      </Typography>
      <Chip label={version} size="small" variant="outlined" color="info" />
    </Box>
  );
}
